import { render, staticRenderFns } from "./CardDocument.vue?vue&type=template&id=f4474daa&scoped=true&"
import script from "./CardDocument.vue?vue&type=script&lang=js&"
export * from "./CardDocument.vue?vue&type=script&lang=js&"
import style0 from "./CardDocument.vue?vue&type=style&index=0&id=f4474daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4474daa",
  null
  
)

export default component.exports